/**
 * @desc 查询中台退货单的mrbNo
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBillFacadeImpl.getMrbNosBySpOrderId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/getMrbNosBySpOrderId`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
